<template>
  <v-row>
    <v-col>
      <v-card class="px-12 py-6">
        <v-row>
          <v-col cols="12" class="py-0 mb-5">
            <app-headline class="mb-1" :title="title" />
            <v-divider></v-divider>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="py-0">
            <v-row>
              <v-col cols="4" sm="2" md="4" lg="3" xl="2" class="py-1">
                <span class="font-weight-bold">รหัสใบลา</span>
              </v-col>
              <v-col class="py-1">
                <span>{{ leaveOrderData.leaveOrder }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="py-0">
            <v-row>
              <v-col cols="4" sm="2" md="4" lg="3" xl="2" class="py-1">
                <span class="font-weight-bold">ชื่อผู้ขอลา</span>
              </v-col>
              <v-col class="py-1">
                <span>{{ leaveOrderData.employeeName }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="py-0">
            <v-row>
              <v-col cols="4" sm="2" md="4" lg="3" xl="2" class="py-1">
                <span class="font-weight-bold">วันที่ขอลา</span>
              </v-col>
              <v-col class="py-1">
                <span>{{ leaveOrderData.date }}</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="py-0"></v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="py-0">
            <v-row>
              <v-col cols="4" sm="2" md="4" lg="3" xl="2" class="py-1">
                &nbsp;
              </v-col>
              <v-col class="py-1">
                <v-btn class="teal white--text ma-1" small depressed @click="onOpenLeaveDocument()">
                  <v-icon class="pr-1" small>mdi-file-document</v-icon>
                  เปิดดูใบลา
                </v-btn>
                <v-btn
                  v-if="leaveOrderData.document"
                  class="secondary white--text ma-1"
                  small
                  depressed
                  @click="onOpenDocument(leaveOrderData)"
                >
                  <v-icon class="pr-1" small>mdi-file-document</v-icon>
                  เปิดดูเอกสารแนบ
                </v-btn>
                <!-- <v-btn class="warning white--text ma-1" small depressed>
                  <v-icon class="pr-1" small>mdi-file-document</v-icon>
                  เปลี่ยนเอกสาร
                </v-btn> -->
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="py-0"></v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    leaveOrderData: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: 'รายละเอียดการลา'
    }
  },

  methods: {
    async onOpenLeaveDocument() {
      let path = `/pdf?store=leave/getLeaveDocumentDownload&FileType=pdf&guid=${this.$guid}&leaveOrderID=${this.$route.params.leaveOrderId}`;
      window.open(path);
    },

    async onOpenDocument(item) {
      try {
        const payload = {
          leaveOrderID: item.leaveOrderId,
          docFileName: item.document
        };
        const res = await this.$store.dispatch('leave/getAttachedDocumentDownload', payload);

        var fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
        var link = document.createElement('a');
        link.href = fileURL;
        link.download = item.document;
        link.click();
      } catch (e) {
        console.log(e.response || e);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
